import { Localizer } from "infrastructure/localization/localizer";

const mergeFieldToolbarButton: toastui.ButtonOptions = {
    className: "rich-text-editor-custom-button rich-text-editor-merge-field-icon tui-toolbar-icons",
    event: "insertMergeField",
    tooltip: Localizer.global_insertMergeField()
}

export default mergeFieldToolbarButton;
